// 주요 증상 아이콘 (DRT-7185). 서버 concern_meta.icon 이름 → 번들 이미지.
// iOS 12 Safari 가 webp 를 못 그려서 기존 증상 아이콘은 png 로 바꿔 넣었다
import symptomAppetite from '~assets/images/concerns/symptom_appetite.svg?url'
import symptomBehavior from '~assets/images/concerns/symptom_behavior.png'
import symptomBreathing from '~assets/images/concerns/symptom_breathing.svg?url'
import symptomDental from '~assets/images/concerns/symptom_dental.svg?url'
import symptomDiarrhea from '~assets/images/concerns/symptom_diarrhea.png'
import symptomEar from '~assets/images/concerns/symptom_ear.png'
import symptomEyes from '~assets/images/concerns/symptom_eyes.png'
import symptomMobility from '~assets/images/concerns/symptom_mobility.svg?url'
import symptomNeuro from '~assets/images/concerns/symptom_neuro.svg?url'
import symptomSkin from '~assets/images/concerns/symptom_skin.png'
import symptomToxin from '~assets/images/concerns/symptom_toxin.svg?url'
import symptomUrination from '~assets/images/concerns/symptom_urination.png'
import symptomVomiting from '~assets/images/concerns/symptom_vomiting.png'

const CONCERN_ICONS: Record<string, string> = {
  symptom_appetite: symptomAppetite,
  symptom_behavior: symptomBehavior,
  symptom_breathing: symptomBreathing,
  symptom_dental: symptomDental,
  symptom_diarrhea: symptomDiarrhea,
  symptom_ear: symptomEar,
  symptom_eyes: symptomEyes,
  symptom_mobility: symptomMobility,
  symptom_neuro: symptomNeuro,
  symptom_skin: symptomSkin,
  symptom_toxin: symptomToxin,
  symptom_urination: symptomUrination,
  symptom_vomiting: symptomVomiting,
}

/** 아이콘 이름의 이미지 주소 (모르는 이름·null 이면 undefined: 아이콘 없이 그린다) */
export const getConcernIcon = (icon: string | null | undefined) =>
  icon ? CONCERN_ICONS[icon] : undefined

/** concern_meta 가 없을 때(예전 서버) 증상 값으로 아이콘 이름을 정한다. eye 만 이름이 다르다 */
export const concernIconName = (value: string) =>
  value === 'others' ? null : value === 'eye' ? 'symptom_eyes' : `symptom_${value}`
